import { useAtom } from 'jotai';
import { db, messaging } from '../services/firebase';
import { userRecordAtom, messageNotificationAtom } from '../state/atoms';
import LOGO from '../../assets/logo.png';

function useMessagingService() {
  const [userRecord, setUserRecord] = useAtom(userRecordAtom);
  const [, setMessageNotification] = useAtom(messageNotificationAtom);

  const getMessageNotifications = async () => {
    // Check if notification permission is granted
    if (userRecord) {
      if (Notification.permission === 'granted') {
        await fetchFCMToken(userRecord);
      } else if (Notification.permission !== 'denied') {
        // Request permission if it's not denied
        try {
          await Notification.requestPermission();
          if (Notification.permission === 'granted') {
            await fetchFCMToken(userRecord);
          }
        } catch (error) {
          console.error('Error requesting notification permission:', error);
        }
      }
    }

    // Handling incoming foreground messages
    messaging.onMessage((payload) => {
      // console.log('Message received. ', payload);

      const notificationTitle = payload.notification.title;
      const notificationOptions = {
        body: payload.notification.body,
        icon: LOGO,
      };
      setMessageNotification({ title: notificationTitle, options: notificationOptions, data: payload.data });
      // Show notification only if permission is granted
      //   if (Notification.permission === 'granted') {
      // eslint-disable-next-line no-new
      // new Notification(notificationTitle, {
      //   body: payload.notification.body,
      //   icon: LOGO,
      // });
      // const notification = new Notification('Hi there!');
      // const showNotification = async (title, options) => new Notification(title, options); // Create the notification only when permission is granted
      // showNotification(notificationTitle, notificationOptions);
      // return notification;
      //   }
    });
  };

  const updateUserTokenInFirestore = async (user, token) => {
    try {
      if (!user || !user.id) {
        console.log('Invalid user');
        return;
      }
      if (!token || !token.length) {
        console.log('Invalid token');
        return;
      }

      const userRef = db.collection('school-admins').doc(user.id);
      await userRef.update({ token });
      setUserRecord((prev) => ({ ...prev, token }));
      console.log(`Updated FCM Token for:`, user.id);
    } catch (error) {
      console.error('Error updating Firestore token:', error);
    }
  };
  const fetchFCMToken = async (user) => {
    try {
      const token = await messaging.getToken({
        vapidKey: process.env.REACT_APP_VAPID_KEY,
      });

      if (!user) {
        console.warn('No user found');
        return;
      }

      if (user.token === token) {
        console.log('FCM Token for this user device already exists');
        return;
      }

      console.log('Fetched new FCM Token:', token);

      // Update Firestore
      await updateUserTokenInFirestore(user, token);

      console.log('Updated FCM Token in Firestore');
    } catch (error) {
      console.error('Error fetching or updating FCM token:', error);
    }
  };

  return { getMessageNotifications };
}
export default useMessagingService;
